export enum AcaoAjustePrecoEnum {
  Somar = 1,
  Subtrair = 2,
}
